import * as React from "react";
const CloseIconSvg = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
    <path
      fill={props.color || "var(--color-primary)"}
      d="M.19 13.5c.264.25.684.25.941 0l5.714-5.72 5.72 5.72c.25.25.684.257.935 0a.662.662 0 0 0 0-.935l-5.714-5.72 5.714-5.72a.656.656 0 0 0 0-.935.675.675 0 0 0-.935 0l-5.72 5.72L1.131.19a.677.677 0 0 0-.94 0 .675.675 0 0 0 0 .935l5.72 5.72-5.72 5.72a.668.668 0 0 0 0 .935Z"
    />
  </svg>
);
export default CloseIconSvg;
